import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateWebSocketState from './webSocket';

export default (state = initialState, action) => chooseReducer(state, action, updateWebSocketState);
